import { Close } from '@ankr.com/ui';
import { Typography } from '@mui/material';

import { closeTopBanner } from 'modules/strapi/store/strapiSlice';
import { useAppDispatch } from 'store/useAppDispatch';

import { useTopBannerStyles } from './useTopBannerStyles';

export interface TopBannerProps {
  children: string | undefined;
  id: string;
  variant?: 'dark' | 'light';
}

export const TopBanner = ({
  children,
  id,
  variant = 'dark',
}: TopBannerProps) => {
  const { classes, cx } = useTopBannerStyles();

  const className = cx(classes.root, classes[variant]);

  const dispatch = useAppDispatch();

  const onCloseIconClick = () => dispatch(closeTopBanner(id));

  return (
    <div className={className}>
      <Typography variant="body3" className={classes.text}>
        {children}
      </Typography>
      <Close
        className={classes.closeIcon}
        onClick={onCloseIconClick}
        size={20}
      />
    </div>
  );
};
